import { BrowserRouter as Router, Route, Routes, NavLink, useLocation } from 'react-router-dom';
import logo from './logo.svg';
import React, { useState, useEffect } from 'react';

import './App.css';
import "slick-carousel/slick/slick.css";         // <-- required for react-slick
import "slick-carousel/slick/slick-theme.css";   // <-- theme styling
import $ from 'jquery';
import Slider from 'react-slick';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';

import ScrollToTop from './ScrollToTop';
import Home from './pages/Home';
import ArticalDetails from './pages/ArticalDetails';
import CoinDetails from './pages/CoinDetails';
import Blogs from './pages/Blogs';
import Guides from './pages/Guides';
import News from './pages/News';
import Launchpad from './pages/Launchpad';
import LaunchpadDetails from './pages/LaunchpadDetails';
import TopGainers from './pages/FilterPages/TopGainers';
import TopLosers from './pages/FilterPages/TopLosers';
import TrendingCoins from './pages/FilterPages/TrendingCoins';
import TopMarketCap from './pages/FilterPages/TopMarketCap';
import DeFi from './pages/FilterPages/DeFi';
import NFT from './pages/FilterPages/NFT';
import AITokens from './pages/FilterPages/AITokens';
import MemeCoins from './pages/FilterPages/MemeCoins';
import GlobalMarket from './pages/FilterPages/GlobalMarket';
import GuideDetails from './pages/GuideDetails';
import SearchBox from './pages/SearchBox'; // adjust path

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const OnOffToggle = ({ isOn, toggle }) => {
  return (
    <div className="onoff-toggle">
      <span
        className={`toggle-option ${!isOn ? 'active' : ''}`}
        onClick={() => toggle(false)}
      >
        OFF
      </span>
      <span
        className={`toggle-option ${isOn ? 'active' : ''}`}
        onClick={() => toggle(true)}
      >
        ON
      </span>
    </div>
  );
};


// Save to cache with expiry
const setCache = (key, data, ttl) => {
  const now = Date.now();
  const expiry = now + ttl;
  const item = { data, timestamp: now, expiry };
  localStorage.setItem(key, JSON.stringify(item));
};

// Load from cache and decide if it's fresh enough
const getCache = (key) => {
  const cached = localStorage.getItem(key);
  if (!cached) return null;

  const { data, timestamp, expiry } = JSON.parse(cached);
  const now = Date.now();

  if (now > expiry) {
    localStorage.removeItem(key);
    return null;
  }

  const isStale = now - timestamp > REFRESH_THRESHOLD;

  return { data, isStale };
};

const CACHE_DURATION = 60 * 1000 * 4; // 4 minute
const REFRESH_THRESHOLD = 60 * 1000; // 15 seconds

const Navbar = () => {
  const location = useLocation();

  return (

  	<ul className="navbar-nav">
			<li className="nav-item">
				<NavLink className={location.pathname === '/news' ? 'nav-link active' : 'nav-link'} to="/news">News</NavLink>
			</li>
			
			<li className="nav-item">
				<NavLink className={location.pathname === '/launchpad' ? 'nav-link active' : 'nav-link'} to={`${homeUrl}launchpad`}>Launchpad</NavLink>
			</li>
			
			{/*<li className="nav-item">
				<NavLink className={location.pathname === '/top-gainers' ? 'nav-link active' : 'nav-link'} to="/top-gainers">Top Gainers</NavLink>
			</li>
			
			<li className="nav-item">
				<NavLink className={location.pathname === '/top-losers' ? 'nav-link active' : 'nav-link'} to="/top-losers">Top Losers</NavLink>
			</li> */}
		</ul>
  );
};


function App() {
  const [topCoins, setTopCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);
  const [isSticky, setIsSticky] = useState(false);

  
  const [showPopup, setShowPopup] = useState(false);


  const fetchData = async () => {
    try {
      const response = await fetch(`${apiUrl}/get-topcoins-data`);
      const data = await response.json();
      setTopCoins(data);
      setCache('TopCoins', data, CACHE_DURATION);
      setLoading(false);      
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const cached = getCache('TopCoins');

    if (cached && !cached.isStale) {
      setTopCoins(cached.data);
    } 
    else {
      fetchData();
    }
  }, []);
	
 const [isDarkMode, setIsDarkMode] = useState(true);

  // Load saved mode from localStorage on component mount
  useEffect(() => {
    const savedMode = localStorage.getItem('isDarkMode');
    if (savedMode !== null) {
      setIsDarkMode(savedMode === 'true');
    }
  }, []);

  // Update localStorage and body class when dark mode changes
  useEffect(() => {
    localStorage.setItem('isDarkMode', isDarkMode);
    document.body.className = isDarkMode ? 'dark-mode' : 'light-mode';
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode((prev) => !prev);
  };

const priceticker_slider = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: true,
    responsive: [
	  {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };

useEffect(() => {
    const fetchRSSfoot = async () => {
      try {
        const rssUrl = 'https://cointelegraph.com/rss/tag/bitcoin';
        const proxyUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(rssUrl)}`;

        const response = await fetch(proxyUrl);
        const data = await response.json(); 
        if(data.items) {
        	setArticles(data.items);
        }
      } catch (err) {
        console.error('Error fetching RSS feed:', err);
      }
    };

    fetchRSSfoot();
  }, []);

	const formatDate = (dateString) => {
	  const date = new Date(dateString);
	  return date.toLocaleString('en-US', {
	    year: 'numeric',
	    month: 'long',
	    day: 'numeric',
	    hour: 'numeric',
	    minute: '2-digit',
	    hour12: true
	  });
	};

  return (
    <Router>
    	<ScrollToTop />
      <div className="App">
        {/* Market Info Section */}
        {/*<div className="top_market_info">
          <div className="container">
            <div className="market_info">
              <ul>
                <li>
                  <span className="titlebox">Coins:</span>
                  <span className="resulttxt">{marketData?.active_cryptocurrencies || 'N/A'}</span>
                </li>
                
                <li>
                  <span className="titlebox">Exchanges:</span>
                  <span className="resulttxt">{marketData?.markets || 'N/A'}</span>
                </li>
                
                <li>
                  <span className="titlebox">Market Cap:</span>
                  <span className="resulttxt">
                    ${(marketData?.total_market_cap?.usd / 1000000000000).toFixed(3)}T
                  </span>
                </li>
                
                <li>
                  <span className="titlebox">24h Vol:</span>
                  <span className="resulttxt">
                    ${(marketData?.total_volume?.usd / 1000000000).toFixed(3)}B
                  </span>
                </li>
                
                <li>
                  <span className="titlebox">Dominance:</span>
                  <span className="resulttxt">
                    BTC {marketData?.market_cap_percentage?.btc?.toFixed(1)}% 
                    ETH {marketData?.market_cap_percentage?.eth?.toFixed(1)}%
                  </span>
                </li>
                
                <li>
                  <span className="titlebox">Gas: </span>
                  <span className="resulttxt">0.0 GWEI</span>
                </li>
              </ul>
            </div>
          </div>
        </div>*/}
        
        {/* Price Ticker Section */}
        <div className="price_ticker">
          <div className="container-fluid">
            <div className="price_ticker_slider animate-ticker">
                {topCoins.length > 0 && topCoins.map((coin) => (
                  <div className="pricetickerbox" key={coin.id}>
                    <div className="boxsec">
                      <span className="coinname">{coin.symbol.toUpperCase()}</span>
                      
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right h-3 w-3 mx-2 text-gray-500">
                        <path d="M5 12h14"></path>
                        <path d="m12 5 7 7-7 7"></path>
                      </svg>
                      
                      <span className="pricetxt">
                        ${coin.current_price < 1 
                          ? coin.current_price.toFixed(6) 
                          : coin.current_price.toFixed(2)}
                      </span>
                      
                      <span className={`updown_price ${coin.price_change_percentage_24h >= 0 ? 'upprice' : 'downprice'}`}>
                        {coin.price_change_percentage_24h >= 0 ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-up h-3 w-3 mr-1">
                            <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                            <polyline points="16 7 22 7 22 13"></polyline>
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-down h-3 w-3 mr-1">
                            <polyline points="22 17 13.5 8.5 8.5 13.5 2 7"></polyline>
                            <polyline points="16 17 22 17 22 11"></polyline>
                          </svg>
                        )}
                        {Math.abs(coin.price_change_percentage_24h).toFixed(1)}%
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
			
			<header className={`header_mainsec ${isSticky ? "sticky" : ""}`}>
				<nav className="navbar navbar-expand-lg">
					<div className="container">
						<a className="navbar-brand" href="/">
							<img className="blacklogo" src={`${homeUrl}/assets/img/text-logo01.png`} />
							<img className="whitelogo" src={`${homeUrl}/assets/img/text-logo01.png`} />
						</a>
						
						<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						
						<div className="collapse navbar-collapse" id="navbarSupportedContent">
							<Navbar />
						</div>
						
						<div className="rightbox">
							
							<div className="searchbox">
							  {!showPopup && (
							    <div className="inputbox">
									<a className="searchicon" href="#" onFocus={() => setShowPopup(true)}><i className="fas fa-search"></i></a>
										{/*<input
							        type="text"
							        placeholder="Search..."
							        onFocus={() => setShowPopup(true)}
										/>*/}
							    </div>
							  )}
							  {showPopup && (
							    <SearchBox onClose={() => setShowPopup(false)} />
							  )}
							</div>

							
							<div className="theme-toggle" onClick={toggleDarkMode}>
								<div className={`toggle-track ${isDarkMode ? 'active' : ''}`}>
									<div className="toggle-thumb">
										🌙
									</div>
								</div>
							</div>
						</div>
					</div>
				</nav>
			</header>
			
			<Routes>      
				<Route exact path="/" element={<Home />} />
				<Route exact path="/artical/:artical_slug" element={<ArticalDetails />} />
				<Route path="/coin/:coin_slug" element={<CoinDetails />} />
				<Route exact path="/blogs" element={<Blogs />} />
				<Route exact path="/guides" element={<Guides />} />
				<Route exact path="/news" element={<News />} />
				<Route exact path="/launchpad" element={<Launchpad />} />
				<Route path="/guides/:slug" element={<GuideDetails />} />
				<Route path="/launchpad/:launchpad_slug" element={<LaunchpadDetails />} />
				
				<Route path="/trending-coins" element={<TrendingCoins />} />
				<Route path="/top-market-cap" element={<TopMarketCap />} />
				<Route path="/defi" element={<DeFi />} />
				<Route path="/nft" element={<NFT />} />
				<Route path="/ai-tokens" element={<AITokens />} />
				<Route path="/meme-coins" element={<MemeCoins />} />
				<Route path="/global-market" element={<GlobalMarket />} />
			</Routes>
			
			<footer>
				<div className="footer_mainsec">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
								<div className="about_contnt">
									<div className="logobox">
										<img className="blacklogo" src={`${homeUrl}/assets/img/text-logo01.png`} />
										<img className="whitelogo" src={`${homeUrl}/assets/img/text-logo01.png`} />
									</div>
									
									<div className="contntbox">
										<p>CoinMediaWorld is a growing independent media outlet committed to delivering real-time news, market insights, and trend updates from the world of cryptocurrency and blockchain technology. Whether you're a curious beginner or a seasoned investor, we’re here to simplify the complex and keep you informed.</p>
									</div>
									
									<div className="social_media">
										<ul>
											<li><a href="https://x.com/home" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-x-twitter"></i></a></li>
											<li><a href="https://www.linkedin.com/company/coinmediaworld/" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in"></i></a></li>
											<li><a href="https://t.me/coinmediaworld" target="_blank" rel="noopener noreferrer"><i className="fab fa-telegram-plane"></i></a></li>
										</ul>
									</div>
								</div>
							</div>
							
							<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
							{/*
								<div className="menu_mainsec">
									<div className="title_box">
										<h3>Categories</h3>
									</div>
									
									<div className="menu_box">
										<ul>
											<li><a href="#">Bitcoin</a></li>
											<li><a href="#">Altcoin</a></li>
											<li><a href="#">Ethereum</a></li>
											<li><a href="#">DeFi</a></li>
											<li><a href="#">Blockchain</a></li>
											<li><a href="#">NFT</a></li>
										</ul>
									</div>
								</div>
								*/}
							</div>
							
							<div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
								<div className="footer_newsbox">
									<div className="title_box">
										<h3>Latest News</h3>
									</div>
									
									<div className="articals_sec">

										{articles.slice(0, 3).map((item, index) => (	

											<div className="articals_mainbox">
												<div className="articals_imgbox">
													<img alt={item.title} src={item.enclosure.link} />
												</div>
												
												<div className="articals_contntbox">
													<div className="artical_contnt">
														<h3><a href={`${homeUrl}artical/${item.title.replace(/[^a-zA-Z0-9 ]/g, '')}?source=Cointelegraph`}>{item.title}</a></h3>
													</div>
													
													<div className="artical_info">
														<span className="time_txt">{formatDate(item.pubDate)}</span>
													</div>
												</div>
											</div>
											))}

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div className="copyright_mainsec">
					<div className="row">
						<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div className="copyright_sec">
								<p>© 2025 CoinMediaWorld. All Rights Reserved.</p>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</div>
	</Router>
  );
}

export default App;
